import {Injectable} from '@angular/core';

import {from, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

interface SubstitutedFont {
  family: string;
  url: string;
  weight: string;
}

const DEJAVU_SANS_REGULAR = 'assets/fonts/dejavu/DejaVuSans.ttf';
const DEJAVU_SANS_BOLD = 'assets/fonts/dejavu/DejaVuSans-Bold.ttf';

// Fonts offered in the editor that are rendered in the browser with a freely distributable substitute
const SUBSTITUTED_FONTS: SubstitutedFont[] = [
  {family: 'Calibri', url: DEJAVU_SANS_REGULAR, weight: '400'},
  {family: 'Calibri', url: DEJAVU_SANS_BOLD, weight: '700'},
  {family: 'Calibri Light', url: DEJAVU_SANS_REGULAR, weight: '400'},
  {family: 'Calibri Light', url: DEJAVU_SANS_BOLD, weight: '700'}
];

type MutableFontFaceSet = FontFaceSet & {
  add(font: FontFace): void;
  delete(font: FontFace): boolean;
};

@Injectable({providedIn: 'root'})
export class EditorFontsService {
  private registeredFonts: FontFace[] = [];

  public register(): Observable<void> {
    if (typeof FontFace === 'undefined' || !document.fonts) {
      return of(undefined);
    }
    this.unregister();
    this.registeredFonts = SUBSTITUTED_FONTS.map(({family, url, weight}) =>
      new FontFace(family, `url(${new URL(url, document.baseURI).href})`, {weight}));
    this.registeredFonts.forEach((font) => this.fontFaceSet.add(font));
    return from(Promise.all(this.registeredFonts.map((font) => font.load())))
      .pipe(map(() => undefined));
  }

  public unregister(): void {
    this.registeredFonts.forEach((font) => this.fontFaceSet.delete(font));
    this.registeredFonts = [];
  }

  private get fontFaceSet(): MutableFontFaceSet {
    return document.fonts as MutableFontFaceSet;
  }
}
